import { render, staticRenderFns } from "./DialogChangeLogisticsStatus.vue?vue&type=template&id=4d691c91"
import script from "./DialogChangeLogisticsStatus.vue?vue&type=script&lang=js"
export * from "./DialogChangeLogisticsStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports